import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const TEAL = [26, 92, 90];
const RED = [255, 68, 68];

const loadImage = (src) =>
  new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        canvas.getContext('2d').drawImage(img, 0, 0);
        resolve({ dataUrl: canvas.toDataURL('image/png'), w: img.naturalWidth, h: img.naturalHeight });
      } catch (e) {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = src;
  });

// Generate a landscape report PDF with a themed header/footer and a table.
export async function generateReportPdf({ title, subtitle, head, body, foot, fileName }) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'landscape' });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const logo = await loadImage('/definitelogo.png');

  const drawHeader = () => {
    const headerH = 26;
    doc.setFillColor(...TEAL);
    doc.rect(0, 0, pageW, headerH, 'F');
    doc.setFillColor(...RED);
    doc.rect(0, headerH, pageW, 1.2, 'F');

    if (logo) {
      const tile = 18;
      doc.setFillColor(255, 255, 255);
      doc.roundedRect(12, 4, tile, tile, 2.5, 2.5, 'F');
      const pad = 2;
      const maxInner = tile - pad * 2;
      const ratio = Math.min(maxInner / logo.w, maxInner / logo.h);
      doc.addImage(logo.dataUrl, 'PNG', 12 + (tile - logo.w * ratio) / 2, 4 + (tile - logo.h * ratio) / 2, logo.w * ratio, logo.h * ratio);
    }

    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(15);
    doc.text(title, 36, 12);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    if (subtitle) doc.text(subtitle, 36, 18);
    doc.setFontSize(9);
    doc.text('Definite Assurance Marine Portal', pageW - 12, 12, { align: 'right' });
    doc.text(new Date().toLocaleString(), pageW - 12, 18, { align: 'right' });
  };

  const drawFooter = () => {
    doc.setFontSize(8);
    doc.setTextColor(120, 120, 120);
    doc.text(
      'Definite Assurance Company Limited  |  +254 708 247 247 / +254 788 247 247  |  customerservice@definiteassurance.com',
      pageW / 2,
      pageH - 6,
      { align: 'center' }
    );
  };

  autoTable(doc, {
    head: [head],
    body,
    foot: foot ? [foot] : undefined,
    startY: 32,
    margin: { top: 32, bottom: 12, left: 12, right: 12 },
    theme: 'grid',
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: TEAL, textColor: 255, fontStyle: 'bold' },
    footStyles: { fillColor: [240, 244, 244], textColor: TEAL, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [247, 249, 249] },
    didDrawPage: () => {
      drawHeader();
      drawFooter();
    }
  });

  doc.save(fileName || 'report.pdf');
}
